import { render, staticRenderFns } from "./PartitionAcceptedDialog.vue?vue&type=template&id=52365b90"
import script from "./PartitionAcceptedDialog.vue?vue&type=script&lang=js"
export * from "./PartitionAcceptedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports